import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ArrowLeft, Flame } from "lucide-react";
import { legalPages } from "../legalContent";
import Footer from "../components/Footer";

const Legal = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const page = legalPages[slug];

  useEffect(() => { window.scrollTo(0, 0); }, [slug]);
  useEffect(() => { if (!page) navigate("/", { replace: true }); }, [page, navigate]);

  if (!page) return null;

  return (
    <div className="bg-white min-h-screen flex flex-col" data-testid={`legal-page-${slug}`}>
      <header style={{ backgroundColor: "#343434" }}>
        <div className="max-w-[1140px] mx-auto px-5 py-3 flex items-center justify-between">
          <button onClick={() => navigate("/")} className="flex items-center gap-2.5" data-testid="legal-logo">
            <span className="w-10 h-10 rounded-sm bg-fire flex items-center justify-center"><Flame className="text-white" size={20} /></span>
            <span className="leading-none text-left">
              <span className="block font-medium text-white text-xl tracking-wide">Stove Scotland</span>
              <span className="block uppercase tracking-[0.22em] text-fire text-[9px] mt-1 font-light">Supply - Install - Maintain</span>
            </span>
          </button>
          <button onClick={() => navigate("/")} className="flex items-center gap-2 text-white hover:text-fire transition-colors text-[15px]" data-testid="legal-back-button">
            <ArrowLeft size={18} /> Back to home
          </button>
        </div>
      </header>

      <main className="flex-1">
        <div className="bg-grey py-10 px-5 text-center">
          <h1 className="text-charcoal font-medium text-[28px] md:text-[34px]" data-testid="legal-title">{page.title}</h1>
          <span className="block mx-auto w-24 h-[1.1px] bg-fire mt-2" />
          <p className="text-gray-500 text-sm mt-3">Last updated: {page.updated}</p>
        </div>
        <article className="max-w-[820px] mx-auto px-5 py-10 md:py-14">
          {page.sections.map((s) => (
            <section key={s.h} className="mb-9">
              <h2 className="text-charcoal font-medium text-[20px] md:text-[22px]">{s.h}</h2>
              <span className="block w-12 h-[1.1px] bg-fire my-2" />
              {s.intro && <p className="text-charcoal text-[16px] leading-relaxed mt-3">{s.intro}</p>}
              {s.list && (
                <ul className="mt-3 space-y-2 list-disc pl-6">
                  {s.list.map((li) => <li key={li} className="text-charcoal text-[16px] leading-relaxed">{li}</li>)}
                </ul>
              )}
              {s.p?.map((t, i) => (
                <p key={i} className="text-charcoal text-[16px] leading-relaxed mt-3">{t}</p>
              ))}
            </section>
          ))}
          <div className="flex flex-wrap gap-3 pt-4 border-t border-[#DDDADA]">
            {Object.entries(legalPages).filter(([k]) => k !== slug).map(([k, v]) => (
              <button key={k} onClick={() => navigate(`/${k}`)} className="text-fire hover:text-charcoal transition-colors text-[15px] font-medium" data-testid={`legal-link-${k}`}>
                {v.title} &rarr;
              </button>
            ))}
          </div>
        </article>
      </main>
      <Footer />
    </div>
  );
};

export default Legal;
